<template>
  <EHSModal
    :headerTitle="$t('History.FormTitle')"
    primaryButtonText="OK"
    :primaryActionFunction="close"
    :hasSecondaryAction="false"
    class="ehs-modal"
  >
    <Layout column center vld-parent>
      <Loading
        :active.sync="loading"
        :canCancel="false"
        :isFullPage="false"
        backgroundColor="#f0f0f0"
        loader="bars"
      />
      <DataTable
        :columns="[
          { property: 'status', label: $t('Status') },
          { property: 'started', label: $t('Started') },
          { property: 'finished', label: $t('Finished') },
          { property: 'total', label: $t('Total') },
          { property: 'success', label: $t('Successful') },
          { property: 'errors', label: $t('Error') },
        ]"
        :data="history"
        :pagination="false"
      >
        <template #content:status="importInfo">
          <Chip :color="statusColor(importInfo.status)" active>{{ importInfo.status }}</Chip>
        </template>
      </DataTable>
    </Layout>
  </EHSModal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import Chip from '@wizer/core/components/chip/Chip'
import DataTable from '@wizer/core/components/data-table/DataTable'
import Layout from '@wizer/core/components/layout/Layout'
import EHSModal from '@/components/EHSModal'
import ImportsStatusDataService from '@/services/ImportsStatusDataService'

export default {
  name: 'HistoryDialog',
  components: {
    Loading,
    EHSModal,
    Chip,
    DataTable,
    Layout,
  },
  props: {
    importId: String,
    statusColor: Function,
  },
  data() {
    return {
      loading: true,
      history: [],
    }
  },
  async mounted() {
    this.history = (await ImportsStatusDataService.getHistory(this.importId)).data
    this.loading = false
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
